import {z} from 'zod';

import {translations} from 'presentation/translations-new';
import {IDENTIFIER_LENGTH, clearLoginMask, validateCPF} from 'presentation/utils';
import {format, parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';

const {invalidCPF, invalidEmail, invalidBirthday, invalidData, requiredField, invalidHealthCard} =
	translations['pt-br'].publicFlow.errors;

const MIN_LOGIN_LENGTH = 8;
const MIN_BIRTHDAY_LENGTH = 10;
const MIN_YEAR = 1900;

export const formSchema = z.object({
	login: z
		.string()
		.trim()
		.min(1, {message: requiredField})
		.refine(val => val.length >= MIN_LOGIN_LENGTH, {message: invalidData})
		.transform(val => (val.includes('@') ? val : clearLoginMask(val)))
		.refine(
			val => {
				if (val.includes('@')) {
					return z.string().email().safeParse(val).success;
				}
				return true;
			},
			{message: invalidEmail},
		)
		.refine(
			val => {
				if (val.length >= 8 && val.length <= 10 && /^\d+$/.test(val)) {
					return false;
				}
				return true;
			},
			{message: invalidCPF},
		)
		.refine(
			val => {
				if (val.length >= 12 && val.length <= 13 && /^[A-Za-z0-9]+$/.test(val)) {
					return false;
				}
				return true;
			},
			{message: invalidHealthCard},
		)
		.refine(
			val => {
				if (val.length >= 15 && /^[A-Za-z0-9]+$/.test(val)) {
					return false;
				}
				return true;
			},
			{message: invalidHealthCard},
		)
		.refine(
			val => {
				if (
					!val.includes('@') &&
					val.length !== IDENTIFIER_LENGTH.cpf &&
					val.length !== IDENTIFIER_LENGTH.carteirinha &&
					/[a-zA-Z]/.test(val) &&
					/\d/.test(val)
				) {
					return false;
				}
				return true;
			},
			{message: invalidEmail},
		)
		.refine(
			val => {
				if (val.length === IDENTIFIER_LENGTH.cpf) {
					return validateCPF(val);
				}
				return true;
			},
			{message: invalidCPF},
		),

	birthday: z
		.string()
		.min(1, {message: requiredField})
		.refine(val => val.length >= MIN_BIRTHDAY_LENGTH, {message: invalidBirthday})
		.transform(val => parse(val, 'P', 0, {locale: ptBR}))
		.pipe(
			z
				.date()
				.max(new Date(), {message: invalidBirthday})
				.refine(date => date.getFullYear() >= MIN_YEAR, {message: invalidBirthday}),
		)
		.transform(val => format(val, 'P', {locale: ptBR})),
});

export type IFormData = z.infer<typeof formSchema>;
